/* 🤖 this file was generated by script */
export const wiconClockRewind = {
  name: 'clock_rewind',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.7 13.5l-2-2-2 2M21 12a9 9 0 11-1.25-4.57M12 7v5l3 2"/></svg>`,
};
